//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('requisitionPlanView', {
//        templateUrl: 'views/components/views/requisitionPlanView/requisitionPlanView.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'requisitionPlanViewService', 'logisticService', 'rememberService', function (stateService, utilityService, requisitionPlanViewService, logisticService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                stockplace_id_from: '',
//                stockplace_id_to: '',
//                productsearch_searchtext: ''
//            };

//            vm.model = {
//                productSearchButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('productsearch_searchtext') },
//                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => vm.searchItems() }
//                ],
//                setting: {},
//                selectListStockPlacesFrom: [],
//                selectListStockPlacesTo: [],
//                itemsListViews: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await requisitionPlanViewService.getSetting())[0];
//            }
            
//            async function loadStocks() {
//                const list = await logisticService.listStocks();

//                vm.model.selectListStockPlacesFrom = list;
//                vm.model.selectListStockPlacesTo = list;
//            }
            
//            async function loadRequisitionPlanViews() {
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_from) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_to) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.productsearch_searchtext, true) !== true) return;

//                vm.model.itemsListViews = [];
                
//                return vm.model.itemsListViews = await requisitionPlanViewService.listRequisitionPlanViews(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'stockplace_id_from':
//                    case 'stockplace_id_to':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    case 'productsearch_searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.productsearch_searchtext, true) !== true) return;

//                        variableValue = vm.model.setting.productsearch_searchtext;
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }
            
//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region SEARCH SUBMIT FUNCTION

//            vm.searchItems = function () {
//                rememberFunc('productsearch_searchtext');
//                loadRequisitionPlanViews();
//            }

//            // #endregion SEARCH SUBMIT FUNCTION

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'productsearch_searchtext':
//                        vm.model.setting.productsearch_searchtext = '';

//                        if (vm.model.setting.productsearch_searchtext === '') {
//                            rememberFunc('productsearch_searchtext');
//                            loadRequisitionPlanViews();
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'stockplace_id_from':
//                    case 'stockplace_id_to':
//                        if (utilityService.validateWatchValue(value, vm.model.setting[id]) !== true) return;

//                        vm.model.setting[id] = value;

//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        rememberFunc(id);
//                        loadRequisitionPlanViews();
//                        break;
//                    case 'productsearch_searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.productsearch_searchtext) !== true) return;

//                        vm.model.setting.productsearch_searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.productsearch_searchtext, true) !== true) return;

//                        if (vm.model.setting.productsearch_searchtext === '') {
//                            rememberFunc('productsearch_searchtext');
//                            loadRequisitionPlanViews();
//                        }
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'productsearch_searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.productsearch_searchtext) !== true) return;

//                        if (vm.model.setting.productsearch_searchtext > '') {
//                            rememberFunc('productsearch_searchtext');
//                            loadRequisitionPlanViews();
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadStocks();
//                loadRequisitionPlanViews();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
